import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { KYC_ROUTE_PATHS } from './config';

export const KYC_ROUTES: TApplicationRoute[] = [
  {
    id: 'kyc',
    path: KYC_ROUTE_PATHS.kyc,
    component: lazy(() => import('./pages/kyc-page')),
    layout: 'default',
    permissions: { scopes: ['kyc'] },
    menu: {
      title: 'pages.users.kyc.title',
    },
  },
];
